var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYesno(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-between-vertical-end",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 13,
    x: 3,
    y: 3,
    rx: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9 22 3-3 3 3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 13,
    x: 14,
    y: 3,
    rx: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYesno);
export default __webpack_public_path__ + "static/media/yesno.3718ca2bee1a320a625288fe5b8267a2.svg";
export { ForwardRef as ReactComponent };